import { defineMessage } from 'react-intl'

/** One descriptor, so the preview heading and the drawer heading cannot be translated twice. */
export const THINGS_TO_DO_HEADING = defineMessage({
  id: 'iUnYwYoKazDoRnD18S3a',
  defaultMessage: 'Things to do in {placeName}',
  description: 'Heading for the trip planner things to do list, used above the preview inside the destination drawer and at the top of the full things to do drawer',
})
